module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-circles-016012c9e43d864920c034fb1d66981a.svg";